export enum AgentMode {
    Agent = "agent",
    Ralph = "ralph",
}

export function cycleAgentMode(current: AgentMode): AgentMode {
    const modes = Object.values(AgentMode);
    const currentIndex = modes.indexOf(current);
    const nextIndex = (currentIndex + 1) % modes.length;
    return modes[nextIndex];
}

const RALPH_COMMAND_PREFIX = "/ona:ralph";

/**
 * Applies the ralph mode prefix to a prompt if ralph mode is enabled.
 */
export function applyAgentModePrefix(prompt: string, agentMode: AgentMode): string {
    if (agentMode === AgentMode.Ralph) {
        return `${RALPH_COMMAND_PREFIX} ${prompt}`;
    }
    return prompt;
}
